import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from "@angular/common/http"

@Injectable({
  providedIn: 'root'
})
export class CompartirServicioService {

  constructor(private _http: HttpClient) { }
  
  consultarPosicionConductor(idServicio: any){
    let url = environment.URL_BASE + 'servicioAuthorization/curso' +  "?idServicio=" + idServicio
    return this._http.get(url)
  }

  consultarPosicionConductorSinAuteticacion(idServicio: any){
    let url = environment.URL_BASE + 'servicio/curso' +  "?idServicio=" + idServicio
    return this._http.get(url)
  }
}
